import {
  type FC
} from 'react';
import {
  Stack,
} from '@mui/joy';
import {
  formatCurrency
} from '@shared/lib';
import {
  KeyValueInfoSection
} from './key-value-info-section.component';

export type DetailsBlockProps = {
  purchaseAmount?: Maybe<number>;
  accountNumber?: Maybe<string>;
};

export const DetailsBlock: FC<DetailsBlockProps> = ({
  accountNumber,
  purchaseAmount,
}) => (
  <Stack width='100%'>
    {accountNumber && (
      <KeyValueInfoSection>
        <KeyValueInfoSection.Key>
          Account number
        </KeyValueInfoSection.Key>
        <KeyValueInfoSection.Value>
          {accountNumber}
        </KeyValueInfoSection.Value>
      </KeyValueInfoSection>
    )}
    {purchaseAmount && (
      <KeyValueInfoSection>
        <KeyValueInfoSection.Key>
          Purchase amount
        </KeyValueInfoSection.Key>
        <KeyValueInfoSection.Value>
          {formatCurrency(purchaseAmount)}
        </KeyValueInfoSection.Value>
      </KeyValueInfoSection>
    )}
  </Stack>
);